var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 97,
    viewBox: "0 0 98 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_689_35423)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 97,
    height: 97,
    rx: 48.5,
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.57251,
    y: -4.51245,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.036,
    y: -4.51245,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6444,
    y: -4.51245,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2528,
    y: -4.51245,
    width: 14.6084,
    height: 14.6084,
    fill: "#E7EDF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2528,
    y: -4.51245,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.8613,
    y: -4.51245,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.4698,
    y: -4.51245,
    width: 14.6084,
    height: 14.6084,
    fill: "#E3E9EF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.4698,
    y: -4.51245,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.0781,
    y: -4.51245,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.57251,
    y: 10.0964,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_689_35423)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.9735,
    y: 10.3767,
    width: 14.6084,
    height: 14.6084,
    fill: "#E3E9EF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.9735,
    y: 10.3767,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeWidth: 0.146084
  })), /*#__PURE__*/React.createElement("rect", {
    x: 12.036,
    y: 10.0964,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6444,
    y: 10.0964,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2528,
    y: 10.0964,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.8613,
    y: 10.0964,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.4698,
    y: 10.0964,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.0781,
    y: 10.0964,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.57249,
    y: 24.7046,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.036,
    y: 24.7046,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6445,
    y: 24.7046,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2528,
    y: 24.7046,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.8613,
    y: 24.7046,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.4698,
    y: 24.7046,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.0781,
    y: 24.7046,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.57251,
    y: 39.3127,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.036,
    y: 39.3127,
    width: 14.6084,
    height: 14.6084,
    fill: "#E7EDF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.036,
    y: 39.3127,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6444,
    y: 39.3127,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2528,
    y: 39.3127,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.8613,
    y: 39.3127,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.4698,
    y: 39.3127,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_689_35423)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.2946,
    y: 39.1841,
    width: 14.6084,
    height: 14.6084,
    fill: "#E3E9EF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.2946,
    y: 39.1841,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeWidth: 0.146084
  })), /*#__PURE__*/React.createElement("rect", {
    x: 85.0781,
    y: 39.3127,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.57249,
    y: 53.9214,
    width: 14.6084,
    height: 14.6084,
    fill: "#E3E9EF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.57249,
    y: 53.9214,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.036,
    y: 53.9214,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6445,
    y: 53.9214,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2528,
    y: 53.9214,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.8613,
    y: 53.9214,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.4698,
    y: 53.9214,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.0781,
    y: 53.9214,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.57249,
    y: 68.5298,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.036,
    y: 68.5298,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6445,
    y: 68.5298,
    width: 14.6084,
    height: 14.6084,
    fill: "#E7EDF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6445,
    y: 68.5298,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2528,
    y: 68.5298,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.8613,
    y: 68.5298,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.4698,
    y: 68.5298,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.0781,
    y: 68.5298,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.57249,
    y: 83.1382,
    width: 14.6084,
    height: 14.6084,
    fill: "#E7EDF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.57249,
    y: 83.1382,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.036,
    y: 83.1382,
    width: 14.6084,
    height: 14.6084,
    fill: "#E7EDF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.036,
    y: 83.1382,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6445,
    y: 83.1382,
    width: 14.6084,
    height: 14.6084,
    fill: "#E7EDF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6445,
    y: 83.1382,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2528,
    y: 83.1382,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.8613,
    y: 83.1382,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.4698,
    y: 83.1382,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.0781,
    y: 83.1382,
    width: 14.6084,
    height: 14.6084,
    stroke: "#C9D4E4",
    strokeOpacity: 0.31,
    strokeWidth: 0.146084
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.0251,
    y: 31.0287,
    width: 62.4923,
    height: 75.7357,
    rx: 4.4082,
    fill: "white",
    stroke: "#9CA3AF",
    strokeWidth: 0.413856
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.3364,
    cy: 42.8234,
    r: 4.55242,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1996,
    y: 40.7539,
    width: 39.7302,
    height: 4.13856,
    rx: 1.65542,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.3364,
    cy: 59.3781,
    r: 4.55242,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1996,
    y: 57.3088,
    width: 39.7302,
    height: 4.13856,
    rx: 1.65542,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.3364,
    cy: 76.7599,
    r: 4.55242,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1996,
    y: 74.6907,
    width: 39.7302,
    height: 4.13856,
    rx: 1.65542,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.3364,
    cy: 92.4865,
    r: 4.55242,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1995,
    y: 90.4172,
    width: 39.7302,
    height: 4.13856,
    rx: 1.65542,
    fill: "#F3F4F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_689_35423"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 97,
    height: 97,
    rx: 48.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_689_35423"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.036,
    y: 10.0964,
    width: 14.6084,
    height: 14.6084,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_689_35423"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.0781,
    y: 39.3127,
    width: 14.6084,
    height: 14.6084,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.c9c1823d3461f0ef930e6e2ca073088a.svg";
export { ForwardRef as ReactComponent };